import { useCallback, useEffect, useMemo, useState } from 'react';
import type { Key } from 'react';

import type { TableRowSelection } from 'antd/es/table/interface';

import type { Connector } from '@/entities/connector';

import type { ConnectorTableRow } from './types';

export const useConnectorSelection = (connectors: Connector[]) => {
  const [selectedRowKeys, setSelectedRowKeys] = useState<string[]>([]);

  const selectedCount = selectedRowKeys.length;
  const selectedConnector = selectedCount === 1 && connectors.find((c) => c.id === selectedRowKeys[0]);

  const rowSelection = useMemo<TableRowSelection<ConnectorTableRow>>(
    () => ({
      selectedRowKeys,
      onChange: (selectedRowKeys: Key[]) => {
        const stringKeys = selectedRowKeys.map((key) => String(key));
        setSelectedRowKeys(stringKeys);
      },
    }),
    [selectedRowKeys]
  );

  const clearSelection = useCallback(() => {
    setSelectedRowKeys([]);
  }, []);

  // 커넥터 목록이 변경될 때, 선택된 커넥터 목록도 업데이트 되도록 함
  useEffect(() => {
    const currentConnectorIds = new Set(connectors.map((connector) => connector.id));

    setSelectedRowKeys((prevKeys) => {
      const filteredKeys = prevKeys.filter((id) => currentConnectorIds.has(id));
      return filteredKeys.length === prevKeys.length ? prevKeys : filteredKeys;
    });
  }, [connectors]);

  return {
    selectedRowKeys,
    selectedConnector,
    selectedCount,
    rowSelection,
    clearSelection,
  } as const;
};
